import {
  Alert,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  MenuItem,
  Paper,
} from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';

import { Input } from '@/components/Input';

import { AttendeeLogCheckerModel } from '../../store/AttendeeLogCheckerModel';

import LogList from './LogList';

import s from './AttendeeLogCheckerPanel.module.scss';

type AttendeeLogCheckerPanelProps = {
  model: AttendeeLogCheckerModel;
};

const AttendeeLogCheckerPanel: React.FC<AttendeeLogCheckerPanelProps> = ({ model }) => {
  const emptyMessage =
    !model.hasTaskFilter && !model.showAllLogs
      ? 'Выберите задачу для проверки логов'
      : 'Нет логов за этот день';

  return (
    <Paper className={s.panel} elevation={3}>
      <h2 className={s.panel__title}>Логи участников</h2>

      <div className={s.panel__controls}>
        <Input
          select
          size="small"
          value={model.selectedUserId ?? ''}
          onChange={(e) => model.setSelectedUser(e.target.value)}
          fullWidth
          SelectProps={{
            displayEmpty: true,
            renderValue: (v: unknown) =>
              v
                ? (model.availableUsers.find((u) => u.uid === v)?.display ?? '')
                : 'Выберите участника',
            MenuProps: {
              PaperProps: {
                sx: {
                  fontFamily: 'Montserrat, sans-serif',
                  '& .MuiMenuItem-root': { fontFamily: 'inherit' },
                },
              },
            },
          }}
        >
          <MenuItem value="">
            <em>Выберите участника</em>
          </MenuItem>
          {model.availableUsers.map((user) => (
            <MenuItem key={user.uid} value={user.uid}>
              {user.display}
            </MenuItem>
          ))}
        </Input>

        <FormControlLabel
          control={
            <Checkbox
              size="small"
              checked={model.showAllLogs}
              onChange={() => model.toggleShowAll()}
            />
          }
          label="Показать все логи за день"
          slotProps={{ typography: { fontSize: '13px' } }}
        />
      </div>

      <div className={s.panel__content}>
        {model.isLoading ? (
          <div className={s.panel__loader}>
            <CircularProgress size={28} />
          </div>
        ) : model.error ? (
          <Alert
            severity="error"
            action={
              <Button size="small" onClick={() => model.retry()}>
                Повторить
              </Button>
            }
          >
            {model.error}
          </Alert>
        ) : (
          <LogList logs={model.filteredLogs} emptyMessage={emptyMessage} />
        )}
      </div>
    </Paper>
  );
};

export default observer(AttendeeLogCheckerPanel);
